<template>
  <div class="grid grid-nogutter justify-content-center dark-bg" id="story">
    <div class="border-test" :style=" 'background-image: url(\'' + border + '\');' "></div>

    <div class="col-12 md:col-10 product-banner-wrapper">
      <div class="grid justify-content-center edge-padding center-vertical">
        <div class="col-12 lg:col-6 lg:flex-order-0 flex-order-1" data-aos="fade-up" data-aos-once="true">
          <div :style="centerOnMobile">
            <h2>Authentic Mānuka Honey</h2>
          </div>
          <div v-if="vuex.isMobile">
            <iframe width="1080" height="420" src="https://www.youtube.com/embed/01VbdDiFUoA?rel=0&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="about-us-video"></iframe>
          </div>
          <p class="paragraph-text">We love taking care of our bees, they are the hardest workers at Wero! Our hives are placed in a range of rural locations in beautiful Aotearoa. When they are ready to be harvested, our other (human) team of ‘worker bees’ go out to the field to carefully collect the honeycomb and make sure our bees are happy.</p>
          <p class="paragraph-text">Honey is then separated from the wild honeycomb. Once separated, the honey is tested for quality. When all of our standards have been met, the honey is attentively stored in our special temperature-controlled room. This process is extremely important as maturing the honey increases it's taste, quality and MGO content. The honey will stay here for 12 - 18 months.</p>
          <p class="paragraph-text">Wero honey is tested by an independent, accredited laboratory. We think our honey is great but believe in having all Wero products quality tested independently to ensure you love it as much as we do! Natural markers in the honey will indicate which jar and quality label the honey will end up in for you to enjoy.</p>
          <p class="paragraph-text">Finally, after a patient and dedicated process our delicious Wero honey makes it into jars, right here in Aotearoa. The jars are made in New Zealand using BPA-free recycled materials so that your Wero honey is delivered to you safely to enjoy!</p>

        </div>
        <div v-if="!vuex.isMobile" class="col-12 lg:col-6 lg:flex-order-1 flex-order-0" data-aos="fade-left" data-aos-once="true">
          <iframe width="1080" height="420" src="https://www.youtube.com/embed/01VbdDiFUoA?rel=0&modestbranding=1" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="about-us-video"></iframe>
        </div>
     </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProcessVideo',

  props: {

  },

  mounted() {

  },

  data() {
    return {
      border: require("../../assets/images/border.png"),
    }
  },

  methods: {
    routeToAbout: function() {
      // Change to about page - and scroll to top !
      this.$router.push({name: "About"});
      window.scrollTo(0, 0);
    },

    scrollDown: function(){
      // Scrolls the page to the products section
      let products = document.getElementById("productBanner");
      if(products){
        window.scrollTo({top: products.offsetTop, behavior: 'smooth'})
      }
    }

  },

  computed: {
    vuex: function(){
      return(this.$store.state);
    },

    centerOnMobile: function(){
      if(this.vuex.isMobile){
        return("width: 100%; display: flex; justify-content: center;");
      }else{
        return("width: 100%")
      }
    }

  },

  watch: {

  }

}

</script>


<style scoped>


  .dark-bg{
    position: relative;
    padding-top: 65px;
    padding-bottom: 40px;
    /*background: rgb(0,0,0);
    background: linear-gradient(0deg, rgba(0,0,0,1) 0%, rgba(37,37,37,1) 57%, rgba(61,61,61,1) 100%);
    */
    background-color: black;
    color: whitesmoke;
    display: flex;
    justify-content: center; /* align horizontal */
    align-items: center; /* align vertical */
    max-width: 100%;
    min-height: 70vh;
  }

  .black-bg-only{
    background-color: black;
  }

  .product-banner-wrapper{
    padding-bottom: 0;
  }

  .about-us-video{
    width: 100%;
    margin-top: 15px;
    box-shadow: 1px 1px 19px rgb(0 0 0 / 30%);
    border-style: solid;
    border-width: 13px;
    border-color: #FFFFFF;
    background-color: transparent;
  }

  .world-image{
    max-width: 100%;
  }

  .center-text{
    text-align: center;
  }

  .center-vertical{
    align-items: center;
  }

  .mobile-button{
    width: 100%;
  }

  .test-image{
    height: 100px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;

  }

</style>


